import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {OverlayPanel} from "primeng/overlaypanel";

import {PurchaseChargeCode} from '../../classes/charge-code';
import {Format} from '../../enums/format.enum';

import {AccountsPayableService} from '@app/finance/accounts-payable/accounts-payable.service';
import {InvoiceSummary} from '@app/shared/classes/invoice-summary';
import {PrimeNgConfig, TableColumn, TableFormat} from "@app/shared";


/**
 * Shows charge allocations in an overlay panel. Make sure to implement output handler method that
 * sets the input variable to null. Otherwise, clicking on the same item will not trigger a change detection.
 * @author JC
 */

@Component({
  selector: 'app-show-charge-code',
  templateUrl: './show-charge-code.component.html',
  styleUrls: ['./show-charge-code.component.css'],
  providers: [AccountsPayableService]
})
export class ShowChargeCodeComponent implements OnInit, AfterViewInit {

  //General Common component
  private _chargeCodes: Array<PurchaseChargeCode>;
  @Input()
  set chargeCodes(value: Array<PurchaseChargeCode>) {
    if (value) {
      this._chargeCodes = value;
    }
  }

  get chargeCodes(): Array<PurchaseChargeCode> {
    return this._chargeCodes;
  }

  //Specific to Account Payable. Scenario: Hitting endpoint on a button click
  private _accountPayable: InvoiceSummary;
  @Input()
  set accountPayable(value: InvoiceSummary) {
    if (value) {
      this._accountPayable = value;
    } else {
      this._accountPayable = new InvoiceSummary();
    }
  }

  get accountPayable(): InvoiceSummary {
    return this._accountPayable;
  }

  @Input()
  noOverlayPanel: boolean = false;

  @Input()
  firstColHeaderStyle: string;

  @Input()
  colSpan: number;

  // standard format and validation
  Format: typeof Format = Format;
  PrimeNgConfig = PrimeNgConfig;

  tableColumns: TableColumn[];

  @ViewChild('overlayPanel') overlayPanel: OverlayPanel;

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.initTableColumns();
  }

  constructor(private dataService: AccountsPayableService,) {
  }

  showCC(event, overlayPanel) {
    console.log(event);
    /* common component : when data is provided in the payload. Exp: tradingPartner.uniqueChargeCodes */
    if (this.chargeCodes) {
      overlayPanel.toggle(event);
    }

    /* account payable specific case :to hit the endpoint to get data. Exp: accountPayable summary screen */
    else {
      let partnerInvoiceId: string = String(this.accountPayable.invoiceId);
      this.dataService.getAllocationChargeCode(partnerInvoiceId).subscribe(res => {
        this.chargeCodes = res;
        overlayPanel.toggle(event);
      });

    }
  }

  @Output()
  handler: EventEmitter<any> = new EventEmitter();

  handleOPClose() {
    this.handler.emit();
  }

  private initTableColumns(): void {
    this.tableColumns = [
      {field: 'chargeNumber', header: 'Charge Code', columnStyle: "width:30%"},
      {field: 'allocationPercent', header: 'Allocation(%)', columnStyle: "width:10%", format: TableFormat.PostFix, postFix: "%"},
      {field: 'allocationAmount', header: 'Ext Price($)', columnStyle: "width:20%;text-align: right", format: TableFormat.Currency},
      {field: 'taxAmount', header: 'Sales Tax($)', columnStyle: "width:15%;text-align: right", format: TableFormat.Currency},
    ];
  }
}
